export const getDimensionsByType = (baseState = [], dimensionsEntities, type) => baseState.get(`${type}`) && baseState.get(`${type}`).map(dimId => dimensionsEntities.get(`${dimId}`));

export const getDimensionLabels = (dimensions = []) => dimensions.map(dimension => dimension.get('label')).join(', ') || 'none specified';

const rangeValues = {
  budgetRange: ['£0', '£250', '£500', '£750', '£1k', '£2k+'],
  numberRange: ['0', '1', '2', '3', '4', '5'],
  tempRange: ['15', '20', '25', '30', '35', '40'],
};

export const getRangeString = (rangeObject, rangeType) => {
  let rangeString;

  if (rangeObject) {
    rangeString = rangeValues[rangeType][rangeObject.get('lowerBound')];
    if (rangeObject.get('upperBound') > rangeObject.get('lowerBound')) {
      rangeString += ` - ${rangeValues[rangeType][rangeObject.get('upperBound')]}`;
    }
  }

  return rangeString || 'none specified';
};

export const getTopMasterIds = (searchResults, length) => {
  let masterIds = '';

  for (let i = 0; i < length; i += 1) {
    const masterId = searchResults.getIn([i, 'masterId']);
    masterIds += masterId ? `${masterId}, ` : '';
  }

  return masterIds.slice(0, -2);
};

export const getUserClassArray = userClassString => userClassString ? userClassString.split('') : [];



/** WEBPACK FOOTER **
 ** ./src/utils/dataLayerHelpers.js
 **/